import { Typography } from "@material-ui/core"

const Extras = (props) => {

  return ( <>
    <Typography>
      If you want to level up your custom song experience, we’ve got some awesome extras:
      <ul>
        <li>
          <b>Custom Lyric Card ($20)</b>: Get a beautifully designed card with your lyrics and a photo of your choice—perfect for gifting or framing!
        </li>
        <li>
          <b>Spotify/Amazon Music Upload ($15)</b>: Want your song streaming alongside the greats? We’ll upload it to Spotify and/or Amazon Music so you can flex on your friends.
        </li>
        <li>
          <b>Expedited Delivery ($25)</b>: Need your song fast? We’ll get it to you within 48 hours after lyric approval, because patience is overrated.
        </li>
      </ul>
      No unnecessary frills—just cool extras to make your song even more special!
    </Typography>
  </> )
}

export default Extras
